import { skipToken } from '@reduxjs/toolkit/query';

import useDefaultCurrency from '../../../hooks/useDefaultCurrency';
import { useGetProductPeekViewQuery } from '../../../redux/services';
import { isKeyInType } from '../../../types/guards';

export const usePeakViewData = ({
  skipQuery,
  productId,
}: {
  skipQuery: boolean;
  productId: string | null;
}) => {
  const { defaultCurrency } = useDefaultCurrency();

  const { data, isLoading } = useGetProductPeekViewQuery(
    skipQuery || !productId ? skipToken : { productId },
  );

  const {
    price,
    department_id: departmentId,
    department_desc: departmentDesc,
    sub_department_id: subDepartmentId,
    sub_department_desc: subDepartmentDesc,
    born_season: season,
    born_event: event,
    material_id: materialId,
    material_desc: materialDesc,
    gender,
    first_date_of_sale: firstDateOfSale,
    style_desc: styleDesc,
    style_id: styleId,
    color_desc: colorDesc,
    color_id: colorId,
    image_url: imageUrl,
    substitution_products: substitutionProducts,
    ltd_sales_units: lifeToDateSales,
  } = data || {};

  const priceTypes =
    price &&
    (Object.keys(price)
      .map((key) => ({
        value: isKeyInType(price, key) ? price[key] : undefined,
        label: key.toUpperCase(),
      }))
      .filter((item) => item.value != null) as {
      value: number;
      label: string;
    }[]);

  const formattedSubstitutionProducts = substitutionProducts?.map(
    (product) => ({
      productId: product.id,
      style: product.style_desc || product.style_id,
      imageUrl: product.image_url,
      color: product.color_desc || product.color_id,
    }),
  );

  return {
    isLoading,
    priceTypes,
    defaultCurrency,
    department: departmentDesc || departmentId,
    subDepartment: subDepartmentDesc || subDepartmentId,
    material: materialDesc || materialId,
    subDepartmentId,
    subDepartmentDesc,
    season,
    event,
    firstSale: firstDateOfSale,
    gender,
    style: styleDesc || styleId,
    color: colorDesc || colorId,
    imageUrl,
    substitutionProducts: formattedSubstitutionProducts,
    lifeToDateSales,
  };
};
